import { useNavigate } from "react-router-dom";
import { Wordmark } from "@/components/ui/Wordmark";

const LINE_STYLE = { stroke: "currentColor", strokeLinecap: "round" as const, strokeWidth: 1.6 };

function EvaluationsIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="4"
        y="2"
        width="24"
        height="28"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
      />
      <line x1="9" y1="9" x2="23" y2="9" {...LINE_STYLE} />
      <line x1="9" y1="14" x2="20" y2="14" {...LINE_STYLE} />
      <line x1="9" y1="19" x2="17" y2="19" {...LINE_STYLE} />
    </svg>
  );
}

function TemplatesIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="4"
        y="2"
        width="24"
        height="28"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
      />
      <line x1="9" y1="9" x2="23" y2="9" {...LINE_STYLE} />
      <line x1="9" y1="14" x2="23" y2="14" {...LINE_STYLE} />
      <line x1="9" y1="19" x2="23" y2="19" {...LINE_STYLE} />
      <line x1="9" y1="24" x2="16" y2="24" {...LINE_STYLE} />
    </svg>
  );
}

export function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="home-page">
      <div className="home-hero">
        <div className="home-logo">
          <img src="/logo.svg" alt="" width="48" height="48" />
        </div>
        <h1 className="home-title">
          <Wordmark />
        </h1>
        <p className="home-description">
          Build structured clinical documentation templates, fill them out as evaluations, and
          generate clean printable reports — all in the browser, with no data leaving your device.
        </p>
      </div>
      <div className="home-cta-cards">
        <button className="home-cta-card" onClick={() => navigate("/fill")}>
          <div className="home-cta-icon">
            <EvaluationsIcon />
          </div>
          <div className="home-cta-label">Evaluations</div>
          <div className="home-cta-desc">Fill out and manage clinical assessments</div>
        </button>
        <button className="home-cta-card" onClick={() => navigate("/templates")}>
          <div className="home-cta-icon">
            <TemplatesIcon />
          </div>
          <div className="home-cta-label">Templates</div>
          <div className="home-cta-desc">Create and edit documentation templates</div>
        </button>
      </div>
    </div>
  );
}
